var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('van-nav-bar',{on:{"click-left":_vm.onClickLeft},scopedSlots:_vm._u([{key:"right",fn:function(){return [_vm._t("right")]},proxy:true},{key:"left",fn:function(){return [_vm._t("left")]},proxy:true},{key:"title",fn:function(){return [_vm._t("title")]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }